import { DataContext } from "@visx/xychart";
import { useContext } from "react";

interface PriceChartDatum {
  readonly time: number;
  readonly value: number;
}

interface LiveDotProps {
  readonly data: ReadonlyArray<PriceChartDatum>;
  readonly color: string;
}

export function LiveDot({ data, color }: LiveDotProps) {
  const { xScale, yScale, margin, innerWidth } = useContext(DataContext);
  if (!xScale || !yScale || !margin || data.length === 0) return null;

  const last = data[data.length - 1];
  if (!last) return null;
  const xFn = xScale as unknown as (v: Date) => number;
  const yFn = yScale as unknown as (v: number) => number;
  const cx = xFn(new Date(last.time));
  const cy = yFn(last.value);

  if (Number.isNaN(cx) || Number.isNaN(cy)) return null;

  const lineLeft = margin.left;
  const lineRight = margin.left + (innerWidth ?? 0);

  return (
    <g>
      <line
        x1={lineLeft}
        x2={lineRight}
        y1={cy}
        y2={cy}
        stroke={color}
        strokeWidth={1}
        strokeDasharray="10 8"
        strokeOpacity={0.4}
      />
      <circle cx={cx} cy={cy} r={4} fill="none" stroke={color} strokeWidth={2}>
        <animate
          attributeName="r"
          values="4;16"
          dur="1.6s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="opacity"
          values="0.8;0"
          dur="1.6s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="stroke-width"
          values="2;0.5"
          dur="1.6s"
          repeatCount="indefinite"
        />
      </circle>
      <circle cx={cx} cy={cy} r={3} fill={color} />
    </g>
  );
}
